/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

 import $ from 'jquery';


 $('.home-hero-slider.slick-initialized').each(function() {
     const length = $(this).find('.slick-slide:not(.slick-cloned)').length;
     $('.hero-slider-controls').find('.slider-dots').append(`<span class="-ml-2 pr-3 py-1.5"> / ${ length }</span>`);
 });


const $homeReasonsSlider = $(".home-reasons-slider");

$homeReasonsSlider.on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(".slide-m-dots-home-reasons-slider").data("theme");
    if (theme) {
      dots.addClass(theme);
    }
  }
  $homeReasonsSlider.removeClass("opacity-0");
});

$homeReasonsSlider.slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: true,
  arrows: true,
  dots: true,
  appendDots: $(".slide-m-dots-home-reasons-slider"),
  nextArrow: $(".slide-m-next-home-reasons-slider"),
  prevArrow: $(".slide-m-prev-home-reasons-slider"),

  responsive: [
    {
      breakpoint: 1536,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 960,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "8%",
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "8%",
      },
    },
  ],
});

$homeReasonsSlider.on("setPosition", function (e, slick) {
  slick.$slides.css("height", slick.$slideTrack.height() + "px");
});
